export default __webpack_public_path__ + "static/media/check-circle-light.39311b7e.svg";